import { createContext } from 'react'

const PriceListContext = createContext()

export default PriceListContext
